/**
 * LiveKit Platform — Client bundle entry point.
 * Exposes everything under window.LK (IIFE via esbuild).
 */

// Re-export livekit-client essentials for advanced usage
const {
  Room, RoomEvent, Track, VideoPresets,
  createLocalTracks, ConnectionState, DataPacket_Kind
} = require('livekit-client');

// Platform modules
const { LKBase }   = require('./lk-base');
const { LKCamera } = require('./lk-camera');
const { LKScreen } = require('./lk-screen');
const { LKAudio }  = require('./lk-audio');
const { LKLive }   = require('./lk-live');

// Track processors (background filters)
const { BackgroundBlur, VirtualBackground, supportsBackgroundProcessors, supportsModernBackgroundProcessors } = require('@livekit/track-processors');

// Noise cancellation — NOT bundled (too heavy: ~5.6MB WASM)
// Loaded dynamically via LKBase.enableNoiseFilter()
// Requires separate script tag: <script src="/livekit/dist/krisp-noise-filter.min.js"></script>

// Shared utilities
const { LK_EVENTS } = require('./lk-events');
const { UI }        = require('./lk-ui');

module.exports = {
  // LiveKit client internals
  Room, RoomEvent, Track, VideoPresets,
  createLocalTracks, ConnectionState, DataPacket_Kind,

  // Platform modules
  LKBase,
  LKCamera,
  LKScreen,
  LKAudio,
  LKLive,

  // Track processors
  BackgroundBlur,
  VirtualBackground,
  supportsBackgroundProcessors,
  supportsModernBackgroundProcessors,


  // Utilities
  LK_EVENTS,
  UI
};
